<template>
  <div class="stepper-view choose-specialist" ref="stepperView">
    <div class="step-head pa-6 pa-md-8">
      <h3 class="step-title" :class="is_mobile ? 'mt-1' : 'mt-1'">
        {{
          locale === "nl"
            ? activity.content.nl.banner.title
            : activity.content.eng.banner.title
        }}
        <v-chip
          :class="activity.type === 'eenopeen' ? '' : 'group-chip'"
          color="var(--company-primary)"
          variant="tonal"
        >
          {{
            activity.type === "eenopeen"
              ? $i18n.locale === "nl"
                ? "1 OP 1"
                : "1 ON 1"
              : $i18n.locale === "nl"
              ? "GROEPSACTIVITEIT"
              : "GROUP ACTIVITY"
          }}
        </v-chip>
      </h3>
      <span class="enroll-date" v-if="changing">
        {{
          toAmsterdamCalendarDate(enroll.date)
            .toLocaleDateString("nl-NL", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })
            .replace(/(\w{3})/, "$1.")
        }}
        {{ enroll.start }} -
        {{ enroll.end }}
      </span>
      <p class="step-subtitle mt-2">
        {{
          $i18n.locale == "nl"
            ? "Kies een datum om te zien wie er dan beschikbaar is, of klik op jouw favoriete specialist om te checken wanneer je terecht kunt."
            : "Choose a date to see who is available, or click on your favorite specialist to check when you can arrive."
        }}
      </p>
    </div>
    <div class="step-body px-6 px-md-8" v-if="ready">
      <label class="input-label" for="choose-date">{{
        $i18n.locale == "nl" ? "Dag(en) selecteren" : "Select day(s)"
      }}</label>
      <k-spacing :y="!is_mobile ? '4' : '1'"></k-spacing>
      <div class="specialist-row pb-8 d-flex" v-if="!is_mobile">
        <div class="w-100" style="max-width: 400px">
          <v-date-picker
            hide-header
            show-adjacent-months
            ref="picker"
            locale="nl"
            class="date-picker-card mb-8"
            v-model="tempSelectedDates"
            :multiple="multiple"
            color="var(--company-primary)"
            :allowed-dates="customAllowedDates"
            @update:modelValue="handleDateSelect"
          />

          <label
            class="input-label"
            for="choose-date"
            v-if="filteredSpecialists().length > 1"
            >{{
              is_mobile
                ? $i18n.locale == "nl"
                  ? "Specialist"
                  : "Specialist"
                : $i18n.locale == "nl"
                ? "Kies jouw favoriete specialist"
                : "Choose your favorite specialist"
            }}</label
          >
          <v-autocomplete
            v-if="filteredSpecialists().length > 1"
            class="mt-3"
            :items="filteredSpecialists()"
            v-model="filteredSpecialistArray"
            :model-value="filteredSpecialistArray"
            item-title="name"
            item-value="id"
            :menu-props="{ contentClass: 'specialist-menu' }"
            return-object="true"
            multiple
            variant="solo"
            density="comfortable"
            hide-details
            @update:modelValue="
              (val) => $emit('update-data', { specialist: val })
            "
          >
            <template v-slot:chip="{ props, item }">
              <span v-if="item.raw.id === 'geen_voorkeur'" class=""
                >Geen voorkeur</span
              >
              <v-chip
                v-else
                class="selected-specialist-chip"
                variant="flat"
                v-bind="props"
                :text="item.raw.name"
              >
                <template #prepend>
                  <v-avatar class="mr-2" size="32">
                    <v-img
                      :src="avatarUrl(item.raw.profilepicture)"
                      @error="handleAvatarError(item.raw.profilepicture)"
                      cover
                    />
                  </v-avatar>
                </template>
              </v-chip>
            </template>

            <template v-slot:item="{ props, item }">
              <v-list-item
                v-bind="props"
                :title="item.raw.name"
                class="specialist-list-item"
              >
                <template v-slot:prepend>
                  <v-checkbox
                    class="select-specialist-checkbox"
                    :model-value="
                      filteredSpecialistArray.some((s) => s.id === item.raw.id)
                    "
                    readonly
                    hide-details
                    density="compact"
                    color="var(--company-primary)"
                  ></v-checkbox>
                  <v-avatar class="ms-3" size="32">
                    <v-img
                      :src="avatarUrl(item.raw.profilepicture)"
                      @error="handleAvatarError(item.raw.profilepicture)"
                      cover
                    />
                  </v-avatar>
                </template>
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>

        <div class="d-flex flex-column ga-4 pl-10 w-100 overflow-y-auto">
          <div
            class="d-flex flex-column ga-4"
            v-for="(date, dindex) in sortDates(localRegisterActivity.dates)"
            :key="dindex"
          >
            <div
              class="specialist-date-card d-flex flex-column pa-4"
              v-for="(slots, specialistName, sIndex) in filterSlots(date.date)"
              :key="specialistName"
            >
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <span class="specialist-date my-auto">
                    {{ capitalizeFirstLetter(formatDay(date.date)) }}
                  </span>
                  <v-avatar
                    v-if="slots.profilepicture"
                    size="32"
                    class="ml-4 mr-2"
                  >
                    <v-img
                      :src="avatarUrl(slots.profilepicture)"
                      @error="handleAvatarError(slots.profilepicture)"
                      cover
                    />
                  </v-avatar>
                  <v-avatar v-else class="ml-4 mr-2" size="32">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <circle cx="16" cy="16" r="16" fill="#F5F5F5" />
                      <mask
                        id="mask0_9494_128187"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="4"
                        y="4"
                        width="24"
                        height="24"
                      >
                        <rect
                          x="4"
                          y="4"
                          width="24"
                          height="24"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_9494_128187)">
                        <path
                          d="M9.85 21.1C10.7 20.45 11.65 19.9375 12.7 19.5625C13.75 19.1875 14.85 19 16 19C17.15 19 18.25 19.1875 19.3 19.5625C20.35 19.9375 21.3 20.45 22.15 21.1C22.7333 20.4167 23.1875 19.6417 23.5125 18.775C23.8375 17.9083 24 16.9833 24 16C24 13.7833 23.2208 11.8958 21.6625 10.3375C20.1042 8.77917 18.2167 8 16 8C13.7833 8 11.8958 8.77917 10.3375 10.3375C8.77917 11.8958 8 13.7833 8 16C8 16.9833 8.1625 17.9083 8.4875 18.775C8.8125 19.6417 9.26667 20.4167 9.85 21.1ZM16 17C15.0167 17 14.1875 16.6625 13.5125 15.9875C12.8375 15.3125 12.5 14.4833 12.5 13.5C12.5 12.5167 12.8375 11.6875 13.5125 11.0125C14.1875 10.3375 15.0167 10 16 10C16.9833 10 17.8125 10.3375 18.4875 11.0125C19.1625 11.6875 19.5 12.5167 19.5 13.5C19.5 14.4833 19.1625 15.3125 18.4875 15.9875C17.8125 16.6625 16.9833 17 16 17ZM16 26C14.6167 26 13.3167 25.7375 12.1 25.2125C10.8833 24.6875 9.825 23.975 8.925 23.075C8.025 22.175 7.3125 21.1167 6.7875 19.9C6.2625 18.6833 6 17.3833 6 16C6 14.6167 6.2625 13.3167 6.7875 12.1C7.3125 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.3125 12.1 6.7875C13.3167 6.2625 14.6167 6 16 6C17.3833 6 18.6833 6.2625 19.9 6.7875C21.1167 7.3125 22.175 8.025 23.075 8.925C23.975 9.825 24.6875 10.8833 25.2125 12.1C25.7375 13.3167 26 14.6167 26 16C26 17.3833 25.7375 18.6833 25.2125 19.9C24.6875 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6875 19.9 25.2125C18.6833 25.7375 17.3833 26 16 26Z"
                          fill="#C0C0C0"
                        />
                      </g>
                    </svg>
                  </v-avatar>
                  <span class="specialist-title my-auto"
                    :style="{ opacity: isPlaceholderSpecialist(specialistName) ? 0.6 : 1 }">{{
                    specialistName
                  }}</span>
                </div>

                <v-btn
                  v-if="totalVisibleCards > 1"
                  variant="text"
                  icon
                  @click="removeSlot(date.date, sIndex, specialistName)"
                >
                  <v-icon>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <mask
                        id="mask0_8557_25369"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_8557_25369)">
                        <path
                          d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                          fill="#858585"
                        />
                      </g>
                    </svg>
                  </v-icon>
                </v-btn>
              </div>
              <label class="input-label mt-5 mb-3" for="choose-date">{{
                $i18n.locale == "nl" ? "Tijdslot selecteren" : "Choose timeslot"
              }}</label>
              <v-chip-group
                v-model="date.slot"
                class="time-chip-group"
                variant="flat"
                selected-class="v-chip--selected"
                column
              >
                <div v-for="(item, cindex) in sortSlots(slots)" :key="cindex">
                  <v-chip
                    class="time-chip"
                    color="var(--company-primary)"
                    :value="item"
                    label
                    v-if="
                      item.type !== 'break' &&
                      functions.slotSelectable(item) &&
                      !item.already_enrolled
                    "
                  >
                    <span> {{ item.start }} - {{ item.end }} </span>
                    <waitlist-badge
                      class="time-chip__waitlist"
                      v-if="functions.slotWaitlist(item)"
                      iconOnly
                      :count="item.waitlist_count"
                      :tooltip="waitlistTooltip(item)"
                    />
                  </v-chip>

                  <v-tooltip
                    location="top"
                    class="rounded-tooltip"
                    v-else-if="item.type !== 'break' && item.already_enrolled"
                  >
                    <template v-slot:activator="{ props }">
                      <div v-bind="props">
                        <v-chip
                          class="time-chip-disabled"
                          color="var(--company-primary)"
                          :disabled="true"
                          label
                        >
                          <span :class="'disabled-text'">
                            {{ item.start }} - {{ item.end }}
                          </span>
                          <v-icon size="20" class="time-chip__info">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="info">
                                <mask
                                  id="mask0_4328_23687"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32"
                                >
                                  <rect
                                    id="Bounding box"
                                    width="32"
                                    height="32"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_4328_23687)">
                                  <path
                                    id="info_2"
                                    d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                    fill="#4E4E4E"
                                  />
                                </g>
                              </g>
                            </svg>
                          </v-icon>
                        </v-chip>
                      </div>
                    </template>
                    <div class="tooltip-area">
                      <span class="text-normal text-white tooltip-text">
                        {{
                          registeractivity.enroll_type === "other_enroll" ||
                          registeractivity.enroll_type === "enroll_new_user"
                            ? $i18n.locale === "nl"
                              ? `Medewerker is al aangemeld voor ${functions.getEnroll(
                                  date.date,
                                  item.start,
                                  item.end,
                                  $i18n.locale,
                                  registeractivity.enroll_type,
                                )} op dit tijdstip.`
                              : `Employee is already registered for ${functions.getEnroll(
                                  date.date,
                                  item.start,
                                  item.end,

                                  $i18n.locale,
                                  registeractivity.enroll_type,
                                )} at this time.`
                            : $i18n.locale === "nl"
                            ? `Je bent al aangemeld voor ${functions.getEnroll(
                                date.date,
                                item.start,
                                item.end,

                                $i18n.locale,
                                registeractivity.enroll_type,
                              )} op dit tijdstip`
                            : `You are already signed up for ${functions.getEnroll(
                                date.date,
                                item.start,
                                item.end,

                                $i18n.locale,
                                registeractivity.enroll_type,
                              )} at this time`
                        }}
                      </span>
                    </div>
                  </v-tooltip>
                  <v-tooltip
                    location="top"
                    class="rounded-tooltip"
                    v-else-if="item.type !== 'break' && item.is_full"
                  >
                    <template v-slot:activator="{ props }">
                      <div v-bind="props">
                        <v-chip
                          class="time-chip-disabled"
                          color="var(--company-primary)"
                          :disabled="true"
                          label
                        >
                          <span :class="'disabled-text'">
                            {{ item.start }} - {{ item.end }}
                          </span>
                          <v-icon size="20" class="time-chip__info">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="info">
                                <mask
                                  id="mask0_4328_23687"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32"
                                >
                                  <rect
                                    id="Bounding box"
                                    width="32"
                                    height="32"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_4328_23687)">
                                  <path
                                    id="info_2"
                                    d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                    fill="#4E4E4E"
                                  />
                                </g>
                              </g>
                            </svg>
                          </v-icon>
                        </v-chip>
                      </div>
                    </template>
                    <div class="tooltip-area">
                      <span class="text-normal text-white tooltip-text">
                        {{
                          $i18n.locale === "nl"
                            ? "Activiteit is vol"
                            : "Activity is full"
                        }}
                      </span>
                    </div>
                  </v-tooltip>
                </div>
              </v-chip-group>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="is_mobile">
        <v-menu
          class=""
          ref="menu"
          :model-value="menu1"
          eager
          location="bottom"
          :close-on-content-click="false"
          scroll-strategy="none"
          min-width="290px"
          @update:model-value="onDateMenuToggle"
        >
          <template v-slot:activator="{ props }">
            <v-text-field
              class="mb-8"
              v-bind="props"
              hide-details
              variant="solo"
              v-model="formattedSelectedDates"
              :placeholder="
                $i18n.locale == 'nl' ? 'Gewenste dag(en)' : 'Selected date(s)'
              "
              readonly
            >
              <template v-slot:append-inner>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z"
                    fill="#858585"
                  />
                </svg>
              </template>
            </v-text-field>
          </template>
          <!-- De kiezer werkt op een concept (draft); pas de bevestigknop
               neemt het over in de stap. Sluiten via het kruisje of wegtikken
               laat de bevestigde keuze staan. -->
          <v-sheet class="mobile-date-picker-menu">
            <div class="mobile-date-picker-menu__header">
              <span>{{ $t("components.registerActivityDialog.dialog_date_l") }}</span>
              <v-btn
                icon
                variant="text"
                density="comfortable"
                :aria-label="
                  $t('components.changeActivityDialogDialog.dialog_close_btn')
                "
                @click="requestCloseDateMenu"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-date-picker
              show-adjacent-months
              hide-header
              ref="picker"
              locale="nl"
              :model-value="draft ? draft.dates : tempSelectedDates"
              v-model:month="pickerMonth"
              v-model:year="pickerYear"
              :multiple="multiple"
              :color="'var(--company-primary)'"
              :allowed-dates="customAllowedDates"
              @update:modelValue="handleDraftDateSelect"
            />
            <div class="mobile-date-picker-menu__footer">
              <v-btn
                block
                class="btn text-white quickfix-btn"
                color="var(--company-primary)"
                :disabled="!draftCount"
                @click="confirmDraftDates"
              >
                {{
                  draftCount > 1
                    ? $t("components.registerActivityDialog.date_picker_confirm_many", {
                        count: draftCount,
                      })
                    : $t("components.registerActivityDialog.date_picker_confirm_one")
                }}
              </v-btn>
            </div>
            <!-- Binnen de menu-inhoud, zodat de vraag een kind van het menu is:
                 anders ziet het menu een tik in de vraag als wegtikken. -->
            <v-dialog
              v-model="discardDialog"
              width="400"
              content-class="card confirm-close-dialog date-discard-dialog"
            >
              <div class="d-flex flex-column ga-4">
                <div class="header">
                  <span class="title">{{
                    $t("components.registerActivityDialog.date_picker_discard_title")
                  }}</span>
                </div>
                <div class="body">
                  <span class="description">{{
                    $t("components.registerActivityDialog.date_picker_discard_text")
                  }}</span>
                </div>
                <div class="d-flex flex-column ga-3 mt-2">
                  <v-btn
                    block
                    variant="flat"
                    class="btn text-white"
                    color="var(--company-primary)"
                    @click="discardDialog = false"
                  >
                    {{ $t("components.registerActivityDialog.date_picker_discard_back") }}
                  </v-btn>
                  <v-btn
                    block
                    variant="outlined"
                    class="btn"
                    color="var(--company-primary)"
                    @click="closeDateMenu"
                  >
                    {{ $t("components.registerActivityDialog.date_picker_discard_confirm") }}
                  </v-btn>
                </div>
              </div>
            </v-dialog>
          </v-sheet>
        </v-menu>
        <label
          class="input-label"
          for="choose-date"
          v-if="filteredSpecialists().length > 1"
          >{{ $i18n.locale == "nl" ? "Specialist" : "Specialist" }}</label
        >
        <v-autocomplete
          v-if="filteredSpecialists().length > 1"
          class="mt-3 s"
          :items="filteredSpecialists()"
          v-model="filteredSpecialistArray"
          :model-value="filteredSpecialistArray"
          item-title="name"
          item-value="id"
          return-object="true"
          multiple
          variant="solo"
          density="comfortable"
          :menu-props="{ contentClass: 'specialist-menu' }"
          hide-details
          @update:modelValue="
            (val) => $emit('update-data', { specialist: val })
          "
        >
        </v-autocomplete>

        <div
          class="activity-slide-group"
          :class="{ 'activity-slide-group--single': totalVisibleCards == 1 }"
        >
          <Swiper
            ref="swiper"
            :slides-per-view="totalVisibleCards >= 2 ? 'auto' : 1"
            :space-between="16"
            :navigation="{ nextEl: '.nav-next', prevEl: '.nav-previous' }"
            @swiper="onSwiper"
            @slide-change="onSwiperSlideChange()"
          >
            <template
              v-for="(date, dindex) in sortDates(localRegisterActivity.dates)"
              :key="dindex"
            >
              <SwiperSlide
                v-for="(slots, specialistName) in filterSlots(date.date)"
                :key="specialistName"
              >
                <div
                  class="slide-group-card pa-4"
                  :class="totalVisibleCards == 1 ? 'w-100' : ''"
                >
                  <div class="d-flex flex-column mb-6">
                    <span class="specialist-date my-auto">
                      {{ capitalizeFirstLetter(formatDay(date.date)) }}
                    </span>
                    <div class="d-flex mt-2">
                      <v-avatar
                        v-if="slots.profilepicture"
                        size="28"
                        class="mr-2"
                        :image="`${configdata.url.cdn}/specialists/avatars/${slots.profilepicture}`"
                      />
                      <v-avatar v-else class="mr-2" size="28">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <circle cx="16" cy="16" r="16" fill="#F5F5F5" />
                          <mask
                            id="mask0_9494_128187"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="4"
                            y="4"
                            width="24"
                            height="24"
                          >
                            <rect
                              x="4"
                              y="4"
                              width="24"
                              height="24"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_9494_128187)">
                            <path
                              d="M9.85 21.1C10.7 20.45 11.65 19.9375 12.7 19.5625C13.75 19.1875 14.85 19 16 19C17.15 19 18.25 19.1875 19.3 19.5625C20.35 19.9375 21.3 20.45 22.15 21.1C22.7333 20.4167 23.1875 19.6417 23.5125 18.775C23.8375 17.9083 24 16.9833 24 16C24 13.7833 23.2208 11.8958 21.6625 10.3375C20.1042 8.77917 18.2167 8 16 8C13.7833 8 11.8958 8.77917 10.3375 10.3375C8.77917 11.8958 8 13.7833 8 16C8 16.9833 8.1625 17.9083 8.4875 18.775C8.8125 19.6417 9.26667 20.4167 9.85 21.1ZM16 17C15.0167 17 14.1875 16.6625 13.5125 15.9875C12.8375 15.3125 12.5 14.4833 12.5 13.5C12.5 12.5167 12.8375 11.6875 13.5125 11.0125C14.1875 10.3375 15.0167 10 16 10C16.9833 10 17.8125 10.3375 18.4875 11.0125C19.1625 11.6875 19.5 12.5167 19.5 13.5C19.5 14.4833 19.1625 15.3125 18.4875 15.9875C17.8125 16.6625 16.9833 17 16 17ZM16 26C14.6167 26 13.3167 25.7375 12.1 25.2125C10.8833 24.6875 9.825 23.975 8.925 23.075C8.025 22.175 7.3125 21.1167 6.7875 19.9C6.2625 18.6833 6 17.3833 6 16C6 14.6167 6.2625 13.3167 6.7875 12.1C7.3125 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.3125 12.1 6.7875C13.3167 6.2625 14.6167 6 16 6C17.3833 6 18.6833 6.2625 19.9 6.7875C21.1167 7.3125 22.175 8.025 23.075 8.925C23.975 9.825 24.6875 10.8833 25.2125 12.1C25.7375 13.3167 26 14.6167 26 16C26 17.3833 25.7375 18.6833 25.2125 19.9C24.6875 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6875 19.9 25.2125C18.6833 25.7375 17.3833 26 16 26Z"
                              fill="#C0C0C0"
                            />
                          </g>
                        </svg>
                      </v-avatar>
                      <span class="specialist-title my-auto"
                        :style="{ opacity: isPlaceholderSpecialist(specialistName) ? 0.6 : 1 }">{{
                        specialistName
                      }}</span>
                    </div>
                  </div>
                  <label class="input-label" for="choose-date">{{
                    $i18n.locale == "nl"
                      ? "Tijdslot selecteren"
                      : "Choose timeslot"
                  }}</label>
                  <v-select
                    class="mt-3 swiper-no-swiping"
                    v-model="date.slot"
                    variant="solo"
                    hide-details
                    :placeholder="
                      $i18n.locale == 'nl'
                        ? 'Tijdslot selecteren'
                        : 'Choose timeslot'
                    "
                    :items="sortSlots(slots)"
                    :item-title="(item) => `${item.start} - ${item.end}`"
                    :item-props="mobileSlotProps"
                    item-value="id"
                    return-object="true"
                    density="compact"
                  >
                    <template #item="{ props, item }">
                      <v-list-item v-bind="props" role="option">
                        <template
                          #append
                          v-if="slotStatus(item.raw) === 'waitlist'"
                        >
                          <waitlist-badge :count="item.raw.waitlist_count" />
                        </template>
                      </v-list-item>
                    </template>
                    <template #selection="{ item }">
                      <span class="text-no-wrap">{{ item.title }}</span>
                      <waitlist-badge
                        class="ml-2"
                        iconOnly
                        :count="item.raw.waitlist_count"
                        v-if="slotStatus(item.raw) === 'waitlist'"
                      />
                    </template>
                  </v-select>

                  <v-btn
                    v-if="totalVisibleCards > 1"
                    class="slide-group-card-trash-btn"
                    variant="text"
                    icon
                    density="compact"
                    @click="removeSlot(date.date, sIndex, specialistName)"
                  >
                    <v-icon>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <mask
                          id="mask0_8557_25369"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_8557_25369)">
                          <path
                            d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                            fill="#858585"
                          />
                        </g>
                      </svg>
                    </v-icon>
                  </v-btn>
                </div>
              </SwiperSlide>
            </template>
          </Swiper>

          <v-btn
            v-if="is_mobile && totalVisibleCards > 1"
            class="slide-group-btn"
            @click="slideGroupNext"
          >
            <v-icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="17"
                viewBox="0 0 10 17"
                fill="none"
              >
                <path
                  d="M1.47917 16.6667L0 15.1875L6.85417 8.33333L0 1.47917L1.47917 0L9.8125 8.33333L1.47917 16.6667Z"
                  fill="#858585"
                />
              </svg>
            </v-icon>
          </v-btn>
        </div>

        <!-- <div class="activity-slide-group">
          <v-slide-group
          v-model="slideGroupModel"
          content-class="d-flex ga-4" :class="dindex > 0 ? 'ml-4' : ''" 
          show-arrows:false
        >
        <template v-for="(date, dindex) in sortDates(localRegisterActivity.dates)" :key="dindex">
              <v-slide-group-item class="slide-group-card pa-4" v-for="(slots, specialistName) in filterSlots(date.date)" :key="specialistName">
                <div class="slide-group-card pa-4" :class="Object.keys(filterSlots(date.date)).length == 1 ? 'w-100' : ''">
                  <div class="d-flex flex-column mb-6">
                    <span class="specialist-date my-auto">
                      {{ capitalizeFirstLetter(formatDay(date.date)) }}
                    </span>
                    <div class="d-flex mt-2">
                      <v-avatar
                        v-if="slots.profilepicture"
                        color="var(--company-primary)"
                        size="28"
                        class="mr-2"
                        :image="`${configdata.url.cdn}/specialists/avatars/${slots.profilepicture}`"
                      />
                      <v-avatar v-else class="mr-2" size="28">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                          <circle cx="16" cy="16" r="16" fill="#F5F5F5" />
                          <mask id="mask0_9494_128187" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
                            <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_9494_128187)">
                            <path
                              d="M9.85 21.1C10.7 20.45 11.65 19.9375 12.7 19.5625C13.75 19.1875 14.85 19 16 19C17.15 19 18.25 19.1875 19.3 19.5625C20.35 19.9375 21.3 20.45 22.15 21.1C22.7333 20.4167 23.1875 19.6417 23.5125 18.775C23.8375 17.9083 24 16.9833 24 16C24 13.7833 23.2208 11.8958 21.6625 10.3375C20.1042 8.77917 18.2167 8 16 8C13.7833 8 11.8958 8.77917 10.3375 10.3375C8.77917 11.8958 8 13.7833 8 16C8 16.9833 8.1625 17.9083 8.4875 18.775C8.8125 19.6417 9.26667 20.4167 9.85 21.1ZM16 17C15.0167 17 14.1875 16.6625 13.5125 15.9875C12.8375 15.3125 12.5 14.4833 12.5 13.5C12.5 12.5167 12.8375 11.6875 13.5125 11.0125C14.1875 10.3375 15.0167 10 16 10C16.9833 10 17.8125 10.3375 18.4875 11.0125C19.1625 11.6875 19.5 12.5167 19.5 13.5C19.5 14.4833 19.1625 15.3125 18.4875 15.9875C17.8125 16.6625 16.9833 17 16 17ZM16 26C14.6167 26 13.3167 25.7375 12.1 25.2125C10.8833 24.6875 9.825 23.975 8.925 23.075C8.025 22.175 7.3125 21.1167 6.7875 19.9C6.2625 18.6833 6 17.3833 6 16C6 14.6167 6.2625 13.3167 6.7875 12.1C7.3125 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.3125 12.1 6.7875C13.3167 6.2625 14.6167 6 16 6C17.3833 6 18.6833 6.2625 19.9 6.7875C21.1167 7.3125 22.175 8.025 23.075 8.925C23.975 9.825 24.6875 10.8833 25.2125 12.1C25.7375 13.3167 26 14.6167 26 16C26 17.3833 25.7375 18.6833 25.2125 19.9C24.6875 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6875 19.9 25.2125C18.6833 25.7375 17.3833 26 16 26Z"
                              fill="#C0C0C0"
                            />
                          </g>
                        </svg>
                      </v-avatar>
                      <span class="specialist-title my-auto"
                        :style="{ opacity: isPlaceholderSpecialist(specialistName) ? 0.6 : 1 }">{{ specialistName }}</span>
                    </div>
                  </div>
                  <label class="input-label" for="choose-date">{{ $i18n.locale == "nl" ? "Tijdslot selecteren" : "Choose timeslot" }}</label>
                  <v-select
                    class="mt-3"
                    v-model="date.slot"
                    variant="solo"
                    hide-details
                    :placeholder="$i18n.locale == 'nl' ? 'Tijdslot selecteren' : 'Choose timeslot'"
                    :items="sortSlots(slots)"
                    :item-title="(item) => `${item.start} - ${item.end}`"
                    item-value="id"
                    return-object="true"
                  >
                  </v-select>
                </div>
              </v-slide-group-item>
            </template>
        </v-slide-group>

        <v-btn v-if="is_mobile && localRegisterActivity.dates.some(date => Object.keys(filterSlots(date.date)).length >= 2)" class="slide-group-btn" @click="slideGroupNext(getCurrentDateMaxSlots())">
          <v-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
              <path d="M1.47917 16.6667L0 15.1875L6.85417 8.33333L0 1.47917L1.47917 0L9.8125 8.33333L1.47917 16.6667Z" fill="#858585"/>
            </svg>
          </v-icon>
        </v-btn>
        </div> -->
      </div>
    </div>

    <loader
      :circle_size="180"
      v-else
      :image="false"
      height="40"
      width="170"
      class="mt-16"
    />
    <div class="step-footer pa-6 pa-md-8 pt-md-10">
      <v-row>
        <v-col cols="12" :class="!is_mobile ? 'd-flex' : ''">
          <v-btn
            v-if="is_mobile"
            :block="is_mobile"
            class="btn text-white quickfix-btn"
            color="var(--company-primary)"
            :disabled="checkDisabled()"
            @click="$emit('next-step')"
          >
            {{ $i18n.locale == "nl" ? "Ga verder" : "Continue" }}
          </v-btn>
          <k-spacing y="4" v-if="is_mobile"></k-spacing>

          <v-btn
            :block="is_mobile"
            v-if="firstStep"
            class="btn quickfix-btn"
            color="var(--company-primary)"
            variant="outlined"
            @click="$emit('close-dialog')"
          >
            {{ $t("components.changeActivityDialogDialog.dialog_close_btn") }}
          </v-btn>
          <v-btn
            :block="is_mobile"
            v-else
            class="btn quickfix-btn"
            color="var(--company-primary)"
            variant="outlined"
            @click="$emit('prev-step')"
          >
            {{ locale === "nl" ? "Stap terug" : "Previous" }}
          </v-btn>
          <k-spacing x="4"></k-spacing>

          <v-btn
            v-if="!is_mobile"
            class="btn text-white quickfix-btn"
            color="var(--company-primary)"
            :disabled="checkDisabled()"
            @click="nextStep()"
          >
            {{ $i18n.locale == "nl" ? "Ga verder" : "Continue" }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import config from "../../config";
import { useMainStore } from "@/stores/store";
import loader from "../loader.vue";
import functions from "@/util/functions";
import WaitlistBadge from "@/components/waitlist-badge.vue";

import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css";
import { getAmsterdamDateKey, toAmsterdamCalendarDate } from "@/util/DateUtil";
import { creditAllowance } from "@/util/activityCredits";

export default {
  components: { loader, Swiper, SwiperSlide, WaitlistBadge },
  props: [
    "activity",
    "locale",
    "registeractivity",
    "locationIndex",
    "is_mobile",
    "stepLabel",
    "multiple",
    "changing",
    "enroll",
  ],
  data() {
    return {
      mainstore: useMainStore(),
      menu1: false,
      // Wat de open mobiele kiezer selecteert, los van de bevestigde keuze
      // (tempSelectedDates/selectedDates/first_select): { dates, selected, firstSelect }.
      draft: null,
      discardDialog: false,
      // De maand die de mobiele kiezer toont. Zonder vaste maand springt
      // Vuetify naar vandaag zodra het concept leeg is.
      pickerMonth: null,
      pickerYear: null,
      filteredSpecialistArray: [],
      slideGroupModel: 0,
      activeDate: null,
      config: config,
      functions: functions,
      tempSelectedDates: this.multiple
        ? [...(this.registeractivity.dates || [])]
        : null,
      selectedDates: [],
      scrollable: false,
      credits: [],
      first_select: true,
      ready: false,
      syncingSpecialists: false,

      period: null,
      localRegisterActivity: JSON.parse(JSON.stringify(this.registeractivity)), // Copy for local updates

      invalidAvatars: [],

      swiper: null,

      removedSlots: [], // Track removed date+specialist combinations
    };
  },
  computed: {
    formattedSelectedDates() {
      if (!this.tempSelectedDates || this.tempSelectedDates.length === 0)
        return "";

      const days = [...this.tempSelectedDates]
        .map((d) => (d instanceof Date ? d : new Date(d)))
        .sort((a, b) => a.getTime() - b.getTime())
        .map((d) => this.formatDayForTextfield(d));

      // Meer dan twee: de eerste twee plus het aantal dat niet in het veld past.
      return days.length > 2
        ? `${days.slice(0, 2).join(", ")} +${days.length - 2}`
        : days.join(", ");
    },

    draftCount() {
      return this.draft ? this.draft.dates.length : 0;
    },

    draftChanged() {
      if (!this.draft) return false;
      const key = (dates) =>
        (dates || []).map((d) => this.dayKey(d)).sort().join();
      return key(this.draft.dates) !== key(this.tempSelectedDates);
    },

    configdata() {
      return config;
    },
    dateIndex() {
      return this.activeDate != null
        ? this.localRegisterActivity.dates.findIndex(
            (d) => d.date === this.activeDate,
          )
        : "no_dateindex";
    },
    totalVisibleCards() {
      return this.localRegisterActivity.dates.reduce((total, date) => {
        return total + Object.keys(this.filterSlots(date.date)).length;
      }, 0);
    },
  },
  watch: {
    filteredSpecialistArray: {
      deep: true,
      handler(newVal, oldVal) {
        if (this._syncingSpecialists) return;

        const NO_PREF_ID = "geen_voorkeur";

        const newArr = Array.isArray(newVal) ? newVal.filter(Boolean) : [];
        const oldArr = Array.isArray(oldVal) ? oldVal.filter(Boolean) : [];

        const newIds = newArr.map((s) => s?.id);
        const oldIds = oldArr.map((s) => s?.id);

        const addedIds = newIds.filter((id) => id && !oldIds.includes(id));

        const hasNoPref = newIds.includes(NO_PREF_ID);

        // 1) If "geen_voorkeur" was ADDED -> keep only that one
        if (addedIds.includes(NO_PREF_ID)) {
          const noPrefObj = newArr.find((s) => s?.id === NO_PREF_ID);
          this.syncingSpecialists = true;
          this.filteredSpecialistArray = noPrefObj ? [noPrefObj] : [];
          this.syncingSpecialists = false;
          return;
        }

        // 2) If another specialist was ADDED while "geen_voorkeur" exists -> remove "geen_voorkeur"
        const addedOther = addedIds.some((id) => id && id !== NO_PREF_ID);
        if (addedOther && hasNoPref) {
          this.syncingSpecialists = true;
          this.filteredSpecialistArray = newArr.filter(
            (s) => s?.id !== NO_PREF_ID,
          );
          this.syncingSpecialists = false;
          return;
        }

        // 3) Safety: if somehow both exist without a clear "added" (e.g. initial set), make it exclusive
        if (hasNoPref && newArr.length > 1) {
          const noPrefObj = newArr.find((s) => s?.id === NO_PREF_ID);
          this.syncingSpecialists = true;
          this.filteredSpecialistArray = noPrefObj ? [noPrefObj] : [];
          this.syncingSpecialists = false;
          return;
        }

        // Only restore removed slots if user actually changed the specialist selection
        // (not during internal sync operations)
        if (!this.syncingSpecialists && addedIds.length > 0) {
          this.removedSlots = [];
        }
      },
    },
    tempSelectedDates(newDates) {
      // Existing logic for subsequent selections
      newDates.forEach((date) => {
        if (!this.localRegisterActivity.dates.some((d) => d.date === date)) {
          this.localRegisterActivity.dates.push({ date, slot: null });
        }
      });

      this.localRegisterActivity.dates =
        this.localRegisterActivity.dates.filter((d) =>
          newDates.includes(d.date),
        );

      if (this.localRegisterActivity.dates.length === 0) {
        this.findFirstAllowedDate();
      }

      this.updateActiveDate();
    },

    localRegisterActivity: {
      deep: true,
      handler(newValue) {
        this.$emit("update-data", newValue); // Sync local data with parent
      },
    },
  },
  mounted() {
    this.checkCredits();
    this.filteredSpecialistArray.push({
      id: "geen_voorkeur",
      profilepicture: "default_avatar_image.png",
      name: this.$i18n.locale === "nl" ? "Geen voorkeur" : "No preference",
      dates: [],
    });
  },

  methods: {
    // Uit @/util/DateUtil, zodat de template hem kan aanroepen.
    toAmsterdamCalendarDate,
    // De kalenderdag van een datum in deze stap, als YYYY-MM-DD. Alles wat hier
    // vergeleken wordt is een lokale middernacht: de cellen van de datumkiezer,
    // en de specialistdatums, die elk scherm dat deze stap opent al met
    // toAmsterdamCalendarDate omzet. De lokale dag ís dus de Amsterdamse dag, in
    // elke tijdzone. toISOString() gaf de UTC-dag, en die valt in Amsterdam een
    // dag eerder: de creditcheck telde zo voor een maandag de week ervoor.
    dayKey(date) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${month}-${day}`;
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSwiperSlideChange(event) {
      console.log("onSwiperSlideChange", event);
    },

    slideGroupNext() {
      if (!this.swiper) return;

      if (this.swiper.isEnd) {
        this.swiper.slideTo(0);
      } else {
        this.swiper.slideNext();
      }
    },

    truncateContent(content) {
      const words = content.split(" ");
      if (words.length > 10) {
        const truncated = words.slice(0, 10).join(" ") + "...";
        return truncated;
      } else {
        return content;
      }
    },
    filteredSpecialists() {
      if (
        !this.activity ||
        !this.activity.locations ||
        typeof this.locationIndex === "undefined" ||
        !this.activity.locations[this.locationIndex]
      ) {
        return [];
      }

      const originalSpecialists =
        this.activity.locations[this.locationIndex]?.specialists || [];

      // Make a copy to avoid mutating original data
      const specialists = [...originalSpecialists];
      const filteredSpecialists = specialists.filter(
        (specialist) =>
          specialist.placeholder !== true &&
          specialist.dates.some(
            (date) => date.slots.some((slot) => functions.slotSelectable(slot)), // Ensure at least one bookable/waitlist slot
          ),
      );
      // Add 'Geen voorkeur' option
      filteredSpecialists.unshift({
        id: "geen_voorkeur",
        profilepicture: "default_avatar_image.png",
        name: this.$i18n.locale === "nl" ? "Geen voorkeur" : "No preference",
        dates: [],
      });

      // Emit update only once after component is mounted or locationIndex changes
      if (filteredSpecialists.length === 1) {
        this.$emit("update-data", { specialist: filteredSpecialists[0].id });
      }

      return filteredSpecialists;
    },
    sortSlots(slots) {
      return (slots || [])
        .filter((s) => Number(s.spots) > 0 && s.type !== "break")
        .sort(
          (a, b) => this.timeToMinutes(a.start) - this.timeToMinutes(b.start),
        );
    },

    // Dezelfde volgorde als de tijdslotchips op desktop: een eigen aanmelding
    // op dit tijdstip gaat voor vol, en vol met wachtlijst blijft kiesbaar.
    // `already_enrolled` zet filterSlots bij het renderen.
    // Het slotje op een vol tijdslot zegt hoeveel er al wachten, zodat je kunt
    // inschatten of aanmelden zin heeft (ClickUp 1240ccedm9c).
    waitlistTooltip(slot) {
      if (functions.inWaitlist(slot)) return this.$t("waitlist.slot_tooltip");
      if (typeof slot.waitlist_count !== "number") return "";
      return slot.waitlist_count > 0
        ? this.$t("waitlist.badge_count", { n: slot.waitlist_count })
        : this.$t("waitlist.badge_empty");
    },

    slotStatus(slot) {
      if (slot.already_enrolled) return "enrolled";
      if (functions.slotWaitlist(slot)) return "waitlist";
      if (slot.is_full) return "full";
      return "free";
    },

    // De tijdslotkeuze op mobiel toonde elk tijdslot kaal en kiesbaar: vol en
    // al-aangemeld waren niet te zien (ClickUp 1240ccednfp). Een tooltip zoals
    // op desktop opent niet op touch, dus de reden staat eronder.
    mobileSlotProps(slot) {
      const status = this.slotStatus(slot);
      if (status === "enrolled") {
        const other =
          this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user";
        return {
          disabled: true,
          subtitle: this.$t(
            other
              ? "components.registerActivityDialog.slot_enrolled_other"
              : "components.registerActivityDialog.slot_enrolled_self",
          ),
        };
      }
      if (status === "full") {
        return { disabled: true, subtitle: this.$t("waitlist.badge_full") };
      }
      return {};
    },

    sortDates(dates) {
      return [...dates].sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
      );
    },

    timeToMinutes(time) {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    },
    updateActiveDate() {
      const dates = this.tempSelectedDates;
      if (dates.length === 1) {
        this.activeDate = dates[0];
      } else {
        const i = dates.indexOf(this.activeDate);
        this.activeDate =
          i !== -1
            ? dates[Math.min(i + 1, dates.length - 1)] // naar volgende datum, maar niet buiten bounds
            : dates[0]; // fallback: eerste datum
      }
    },
    checkDateIfNeeded(date, start, end) {
      if (this.getCookie("fmw_access_token")) {
        return this.functions.checkDate(
          date,
          start,
          end,
          this.registeractivity.enroll_type,
        );
      } else {
        return false;
      }
    },
    formatText() {
      if (this.registeractivity.enroll_type == "self_enroll") {
        return this.$i18n.locale == "nl"
          ? "Leuk dat jij je aanmeldt voor:"
          : "Nice of you to sign up for:";
      } else {
        return this.$i18n.locale == "nl"
          ? "Leuk dat je een medewerker wilt aanmelden voor:"
          : "Nice of you to sign somebody up for:";
      }
    },
    scroll() {
      const form = this.$refs[`step${this.step}Form`];

      // Scroll down the active form
      if (form) {
        const el = form.$el || form;
        el.scrollBy({
          top: 100, // Adjust as needed
          behavior: "smooth",
        });
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)"),
      );
      return match ? match[2] : null;
    },
    // Dezelfde periodesleutel als StepThreeGroup en als creditPeriodStart in de
    // API: rekenen op de kalenderdag zelf, niet op een Date in de tijdzone van
    // de browser (die schoof west van Greenwich een dag terug).
    getPeriodStartDate(date, period) {
      return this.functions.getPeriodStartYmd(date, period);
    },

    // "Nog niet bekend" staat lichtgrijs (ClickUp 1240ccekkc7). De slots zijn
    // hier per naam gegroepeerd, dus de vlag komt van de specialist met die
    // naam — nooit van de naam zelf (CONTEXT.md, Nog niet bekend).
    isPlaceholderSpecialist(name) {
      return (this.activity?.locations?.[this.locationIndex]?.specialists || []).some(
        (specialist) => specialist.name === name && specialist.placeholder === true,
      );
    },
    filterSlots(date) {
      if (!date) return {}; // Return empty object if no date is provided

      // Format the input date to YYYY-MM-DD
      const formattedInputDate = new Date(date)
        .toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2"); // MM/DD/YYYY → YYYY-MM-DD

      const groupedSlots = {};

      // Build an allow-list from filteredSpecialistArray (supports ids or objects)
      const allowedIds = new Set();
      const allowedNames = new Set();
      (this.filteredSpecialistArray || []).forEach((s) => {
        if (s && typeof s === "object") {
          if (s.id != null) allowedIds.add(s.id);
          if (s.name) allowedNames.add(s.name);
        } else if (s != null) {
          allowedIds.add(s);
          allowedNames.add(s);
        }
      });

      // Loop through all specialists in the selected location
      for (const specialist of this.activity.locations[this.locationIndex]
        ?.specialists || []) {
        const { id, name, profilepicture, dates } = specialist;

        // If filteredSpecialistArray has entries, skip specialists not in it
        if (
          (allowedIds.size || allowedNames.size) &&
          !allowedIds.has("geen_voorkeur") &&
          !allowedIds.has(id) &&
          !allowedNames.has(name)
        ) {
          continue;
        }

        // Loop through each date of the specialist
        for (const { date: specialistDate, slots } of dates) {
          const formattedSpecialistDate = new Date(specialistDate)
            .toLocaleDateString("en-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
            .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2");

          // If the specialist has available slots for the selected date
          if (formattedSpecialistDate === formattedInputDate) {
            // Skip this specialist if it's been removed for this date
            const isRemoved = this.removedSlots.some(
              (removed) =>
                removed.date === formattedInputDate &&
                removed.specialistName === name,
            );

            if (isRemoved) {
              continue; // Skip adding this specialist to groupedSlots
            }

            if (!groupedSlots[name]) {
              groupedSlots[name] = [];
              groupedSlots[name].profilepicture = profilepicture; // ✅ add it here
              // groupedSlots[name].id = id; // (optional) useful too
            }

            // Add unique slots to the specialist
            slots.forEach((slot) => {
              if (!groupedSlots[name].some((s) => s.start === slot.start)) {
                slot.already_enrolled = this.checkDateIfNeeded(
                  date,
                  slot.start,
                  slot.end,
                );
                if (slot.spots > 0) groupedSlots[name].push(slot);
              }
            });

            if (groupedSlots[name].length === 0) delete groupedSlots[name];
          }
        }
      }

      return groupedSlots; // Return grouped slots per specialist
    },

    // Uitgelogd (openbare pagina) is er geen gebruiker wiens boekingen tellen:
    // elke periode krijgt het volle aantal van de pagina. Sleutel ze zoals de
    // kiezer ze opzoekt, met getPeriodStartDate over de dagen van deze
    // activiteit. Een kalender die vanaf de 1e in stappen van 7 dagen liep gaf
    // geen maandagen, dus bij credits per week was elke dag "op".
    getMaxCreditsForPeriod() {
      // Eigen credits van de activiteit winnen van die van de pagina (86c6gv8yw).
      const { credits, period } = creditAllowance(
        this.mainstore.companypage.settings,
        this.activity,
      );
      // handleDateSelect vergelijkt met === 1, dus een getal; null is geen limiet.
      const maxCredits = credits === null ? 100000 : credits;
      const periodCredits = {};

      for (const day of this.getCustomAllowedDates()) {
        periodCredits[this.getPeriodStartDate(day, period)] = maxCredits;
      }

      return periodCredits;
    },

    checkDisabled() {
      var check = [];
      if (this.registeractivity.dates.length == 0) {
        return true;
      } else {
        this.registeractivity.dates.forEach((element) => {
          if (element.slot) {
            check.push(true);
          }
        });
        if (check.includes(true)) {
          return false;
        } else {
          return true;
        }
      }
    },
    nextStep() {
      this.localRegisterActivity.dates = (
        this.localRegisterActivity.dates || []
      ).filter((d) => d && d.slot);
      this.$emit("update-data", this.localRegisterActivity); // Sync local data with parent

      this.$emit("next-step");
    },
    checkCredits() {
      const token = this.getCookie("fmw_access_token");

      if (token) {
        api
          .post(
            `${config.url.api}/v1/activities/${this.activity.page}/checkcredits`,
            {
              dates: this.getCustomAllowedDates(),
              type: this.registeractivity.enroll_type,
              user: this.registeractivity.user?.id ?? null,
              activity: this.activity.id,
            },
          )
          .then((res) => {
            this.credits = res.data.dates;
            this.period = res.data.period;
            if (this.changing && this.enroll.date) {
              const formattedEnrollDate = this.getPeriodStartDate(
                getAmsterdamDateKey(this.enroll.date),
                this.period,
              );

              if (this.credits[formattedEnrollDate]) {
                this.credits[formattedEnrollDate] += 2;
              } else {
                this.credits[formattedEnrollDate] = 2;
              }
            }
            this.findFirstAllowedDate();
            this.ready = true;
          });
      } else {
        this.credits = this.getMaxCreditsForPeriod();
        this.period = creditAllowance(this.mainstore.companypage.settings, this.activity).period;
        this.findFirstAllowedDate();
        this.ready = true;
      }
    },
    getCustomAllowedDates() {
      const allowedDates = [];

      const filtered = this.filteredSpecialistArray || [];

      // Build allow-list (supports [1,2,3] or [{id:1}, ...])
      const allowedIds = new Set(
        filtered
          .map((s) => (s && typeof s === "object" ? s.id : s))
          .filter((v) => v !== null && v !== undefined),
      );

      const showAll = allowedIds.size === 0 || allowedIds.has("geen_voorkeur");

      for (const { id, dates } of this.activity.locations[this.locationIndex]
        ?.specialists || []) {
        // If filter is active, skip specialists not allowed
        if (!showAll && !allowedIds.has(id)) continue;

        for (const { date: specialistDate, slots } of dates) {
          if (!slots || slots.length === 0) continue;

          allowedDates.push(this.dayKey(specialistDate));
        }
      }

      return [...new Set(allowedDates)];
    },

    findFirstAllowedDate() {
      // If there are already dates with selected slots, preserve them
      const hasExistingSelections = this.localRegisterActivity.dates.some(
        (d) => d && d.slot,
      );
      if (hasExistingSelections) {
        this.tempSelectedDates = this.localRegisterActivity.dates.map(
          (d) => new Date(d.date),
        );
        this.selectedDates = [...this.tempSelectedDates];
        this.first_select = false;
        this.syncActiveDate();
        return;
      }

      let date = new Date();
      date.setHours(0, 0, 0, 0);

      // Zoek door tot de laatste datum die de activiteit aanbiedt, niet een
      // vast jaar vooruit: lag de eerstvolgende datum verder weg, dan vond de
      // scan niets en opende de kiezer op vandaag, met alleen grijze dagen
      // (ClickUp 1240ccecchg).
      const lastAllowed = this.getCustomAllowedDates().sort().pop();
      const until = lastAllowed ? new Date(`${lastAllowed}T00:00:00`) : null;

      while (until && date <= until) {
        const formatted = this.dayKey(date);
        const periodStart = this.getPeriodStartDate(formatted, this.period);
        const credit = this.credits[periodStart] ?? 0;

        // Count selected dates in the same period
        const datesInPeriod = this.selectedDates.filter((d) => {
          const dFormatted = this.dayKey(d);
          return (
            this.getPeriodStartDate(dFormatted, this.period) === periodStart
          );
        });

        if (this.customAllowedDates(date) && datesInPeriod.length < credit) {
          this.tempSelectedDates = [new Date(date)];
          this.localRegisterActivity.dates = [
            { date: new Date(date), slot: null },
          ];
          break;
        }

        date.setDate(date.getDate() + 1);
      }
      this.syncActiveDate();
    },

    handleDateSelect(newDates) {
      console.log("new dates", newDates);

      // Restore removed slots when dates change
      this.removedSlots = [];

      const next = this.nextDateSelection(
        newDates,
        this.selectedDates,
        this.first_select,
      );
      this.selectedDates = next.dates;
      this.tempSelectedDates = [...next.dates];
      this.first_select = next.firstSelect;

      this.syncActiveDate();
    },

    // De selectie na een tik in de kiezer, gerekend vanaf de gekozen dagen
    // (previousDates) en first_select. Raakt de stap zelf niet aan, zodat de
    // mobiele kiezer dezelfde creditregels op zijn concept kan toepassen.
    nextDateSelection(newDates, previousDates, firstSelect) {
      if (!this.multiple) {
        newDates = [newDates];
      }

      const formattedNewDates = newDates.map((date) => new Date(date));

      // ✅ FORCE replace on first select, always overwrite dates
      var addedDate = null;
      if (firstSelect) {
        addedDate = formattedNewDates[1];
      } else {
        addedDate = formattedNewDates.find(
          (d) => !previousDates.some((pd) => pd.getTime() === d.getTime()),
        );
      }
      if (!addedDate) {
        // Handle deselection
        return { dates: formattedNewDates, firstSelect };
      }

      const formattedInputDate = this.dayKey(addedDate);
      const periodStartDate = this.getPeriodStartDate(
        formattedInputDate,
        this.period,
      );
      const creditForPeriod = this.credits[periodStartDate] ?? 0;

      const datesGroupedByPeriod = previousDates.reduce((acc, date) => {
        const formattedDate = this.dayKey(date);
        const periodStart = this.getPeriodStartDate(formattedDate, this.period);
        if (!acc[periodStart]) acc[periodStart] = [];
        acc[periodStart].push(date);
        return acc;
      }, {});

      const existingDatesInPeriod = datesGroupedByPeriod[periodStartDate] || [];

      const isAlreadyInPeriod = existingDatesInPeriod.some(
        (date) => date.getTime() === addedDate.getTime(),
      );
      // CASE 1: Under credit limit
      if (existingDatesInPeriod.length < creditForPeriod) {
        if (firstSelect && formattedNewDates.length > 1) {
          // Replace with only the clicked date
          return { dates: [formattedNewDates[1]], firstSelect: false };
        }
        return { dates: [...previousDates, addedDate], firstSelect };
      }

      // CASE 2: Replace when credit is 1
      if (
        creditForPeriod === 1 &&
        existingDatesInPeriod.length === 1 &&
        !isAlreadyInPeriod
      ) {
        if (firstSelect && formattedNewDates.length > 1) {
          // Replace with only the clicked date
          return { dates: [formattedNewDates[1]], firstSelect: false };
        }
        const updated = previousDates.filter((date) => {
          const datePeriod = this.getPeriodStartDate(
            this.dayKey(date),
            this.period,
          );
          return datePeriod !== periodStartDate;
        });

        return { dates: [...updated, addedDate], firstSelect };
      }

      // CASE 3: No credits left
      this.$toast.error(
        this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
          ? this.$i18n.locale === "nl"
            ? "De medewerker heeft niet voldoende credits voor een aanmelding in deze periode."
            : "The employee does not have enough credits for a registration in this period."
          : this.$i18n.locale === "nl"
          ? "Sorry! Je credits voor deze periode zijn helaas op."
          : "Sorry! You don't have any more credits for this period.",
      );

      return { dates: [...previousDates], firstSelect };
    },

    // ── Mobiele kiezer ──────────────────────────────────────────────────────
    // Openen begint een concept vanaf de bevestigde keuze; de stap (en de
    // tijdsloten eronder) verandert pas bij de bevestigknop.
    onDateMenuToggle(open) {
      if (open) {
        this.draft = {
          dates: [...(this.tempSelectedDates || [])],
          selected: [...this.selectedDates],
          firstSelect: this.first_select,
        };
        const last = this.draft.dates[this.draft.dates.length - 1];
        if (last) {
          this.pickerMonth = new Date(last).getMonth();
          this.pickerYear = new Date(last).getFullYear();
        }
        this.menu1 = true;
      } else {
        this.requestCloseDateMenu();
      }
    },

    handleDraftDateSelect(newDates) {
      const next = this.nextDateSelection(
        newDates,
        this.draft.selected,
        this.draft.firstSelect,
      );
      this.draft = {
        dates: [...next.dates],
        selected: next.dates,
        firstSelect: next.firstSelect,
      };
    },

    confirmDraftDates() {
      if (this.draftChanged) {
        this.removedSlots = [];
        this.selectedDates = this.draft.selected;
        this.tempSelectedDates = [...this.draft.dates];
        this.first_select = this.draft.firstSelect;
        this.syncActiveDate();
      }
      this.menu1 = false;
    },

    // Kruisje, wegtikken of Escape: bij een gewijzigd concept eerst vragen.
    requestCloseDateMenu() {
      if (this.draftChanged) {
        this.discardDialog = true;
      } else {
        this.closeDateMenu();
      }
    },

    closeDateMenu() {
      this.discardDialog = false;
      this.menu1 = false;
    },

    removeSlot(dateValue, sIndex, specialistName) {
      // Format date using same method as filterSlots
      const formattedDate = new Date(dateValue).toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      // Find the date object in localRegisterActivity.dates
      const dateObj = this.localRegisterActivity.dates.find((d) => {
        const formattedD = new Date(d.date).toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        return formattedD === formattedDate;
      });

      // Check if selected slot belongs to this specialist - if so, deselect it
      if (dateObj && dateObj.slot) {
        const slotsForDate = this.filterSlots(dateValue);
        const specialistSlots = slotsForDate[specialistName];

        if (
          specialistSlots &&
          specialistSlots.some(
            (slot) =>
              slot.start === dateObj.slot.start &&
              slot.end === dateObj.slot.end,
          )
        ) {
          dateObj.slot = null;
        }
      }

      // Add to removedSlots array to hide this combination
      this.removedSlots.push({
        date: formattedDate,
        specialistName: specialistName,
      });
    },

    syncActiveDate() {
      this.activeDate =
        this.selectedDates.find((date) => {
          const formatted = this.dayKey(date);
          const periodStart = this.getPeriodStartDate(formatted, this.period);
          const credit = this.credits[periodStart] ?? 0;

          const datesInSamePeriod = this.selectedDates.filter((d) => {
            const p = this.getPeriodStartDate(this.dayKey(d), this.period);
            return p === periodStart;
          });

          return datesInSamePeriod.length <= credit;
        }) || null;
    },

    spliceDate(date) {
      this.tempSelectedDates = this.tempSelectedDates.filter((d) => d !== date);
      this.selectedDates = this.selectedDates.filter((d) => d !== date);

      this.syncActiveDate();
    },

    formatDay(date) {
      if (!date) return "";

      let parsedDate = null;

      if (date instanceof Date) {
        parsedDate = date;
      } else if (typeof date === "string") {
        const dateString = date.trim();
        const ymdMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);

        if (ymdMatch) {
          const [, y, m, d] = ymdMatch;
          parsedDate = new Date(Number(y), Number(m) - 1, Number(d));
        } else {
          parsedDate = new Date(dateString);
        }
      } else {
        parsedDate = new Date(date);
      }

      if (!(parsedDate instanceof Date) || Number.isNaN(parsedDate.getTime())) {
        return "";
      }

      return parsedDate.toLocaleDateString("nl-NL", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    formatDayForTextfield(date) {
      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${day}-${month}-${year}`; // 20-12-2025
    },

    customAllowedDates(date) {
      const formattedDate = this.dayKey(date);

      const filtered = this.filteredSpecialistArray || [];

      // Supports [id, id] or [{ id }, { id }]
      const allowedIds = new Set(
        filtered
          .map((s) => (s && typeof s === "object" ? s.id : s))
          .filter((v) => v !== null && v !== undefined),
      );

      const showAll = allowedIds.size === 0 || allowedIds.has("geen_voorkeur");

      return (
        this.activity.locations[this.locationIndex]?.specialists || []
      ).some(
        ({ id, dates }) =>
          (showAll || allowedIds.has(id)) &&
          dates.some(
            ({ date: specialistDate, slots }) =>
              this.dayKey(specialistDate) === formattedDate &&
              slots?.length > 0,
          ),
      );
    },

    emitUpdateAndNextStep() {
      this.$emit("update-data", this.localRegisterActivity);
      this.$emit("next-step");
    },

    avatarUrl(image) {
      const fallback = `${this.configdata.url.cdn}/specialists/avatars/default_avatar_image.png`;
      if (!image || this.invalidAvatars.includes(image)) {
        console.log("fallback", fallback);
        return fallback;
      }

      return `${this.configdata.url.cdn}/specialists/avatars/${image}`;
    },

    handleAvatarError(image) {
      console.log("avatar error", image);
      if (!this.invalidAvatars.includes(image)) {
        this.invalidAvatars.push(image);
      }
    },

    getCurrentDateMaxSlots() {
      // Calculate which date contains the current slideGroupModel index
      let slideCount = 0;
      for (let i = 0; i < this.localRegisterActivity.dates.length; i++) {
        const slotsForDate = Object.keys(
          this.filterSlots(this.localRegisterActivity.dates[i].date),
        ).length;
        if (this.slideGroupModel < slideCount + slotsForDate) {
          // Found the date that contains the current slide
          return slotsForDate;
        }
        slideCount += slotsForDate;
      }
      // Fallback: return 1 if calculation fails
      return 1;
    },
  },
};
</script>